import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { PlacementSession } from '../../_models/tutor-reports/placement-session.model';
import { SessionMonth, SessionWeek } from '../../_models/placement-search/search-placement-result.model';


@Component({
    selector: 'session-overview-session-calendar',
    templateUrl: './session-overview-session-calendar.component.html',
    styleUrls: ['./session-overview-session-calendar.component.css'],
    standalone: false
})
export class SessionOverviewSessionCalendarComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() sessionCalendar: Array<SessionMonth>;
  @Input() sessionContainer: Element;
  @Input() isExternal: boolean;
  @Input() showNavButtons: boolean = false;
  @Input() wrapOnMonth: boolean = false;
  @Input() wrapWeeks: boolean = false;
  /**
   * Statuses to show. Empty = show every session (the default, so hosts that don't filter — e.g.
   * the placement overview — are unaffected). When populated, only sessions whose status is listed
   * render, and weeks/months with nothing left to show are hidden.
   */
  @Input() statusFilter: string[] = [];
  @Output() sessionSelected = new EventEmitter<PlacementSession>();
  @Output() blocksRenderComplete = new EventEmitter<any>();

  @ViewChild("calendarContainer", { static: false }) calendarContainer: ElementRef;

  private weekday: string[] = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"];

  public sessionCalendarCurrent: Array<SessionMonth> = new Array<SessionMonth>();
  public sessionCalendarFuture: Array<SessionMonth> = new Array<SessionMonth>();

  public hideFutureSessions: boolean = true;

  constructor() { }

  ngOnInit() {
    this.populateSessionCalendar();
    this.hideFutureSessions = !this.isExternal;
  }
  
  ngOnChanges(): void {
    this.setParentHeight();
  }

  ngAfterViewInit() {        
    this.blocksRenderComplete.emit(true);
    this.setParentHeight();
  } 

  public setDisplayDay(date: any): string {
    return this.weekday[new Date(date).getDay()];
  }

  /** A session is shown when no status filter is active, or its status is one of the selected ones. */
  public isStatusVisible(status: string): boolean {
    return this.statusFilter.length === 0 || this.statusFilter.indexOf(status) !== -1;
  }

  /** A week renders only while it still has at least one visible session under the active filter. */
  public weekHasVisibleSession(week: SessionWeek): boolean {
    return week.sessions.some(session => this.isStatusVisible(session.status));
  }

  /** A month renders only while it still has at least one visible week under the active filter. */
  public monthHasVisibleSession(month: SessionMonth): boolean {
    return month.sessionWeeks.some(week => this.weekHasVisibleSession(week));
  }

  public setParentHeight(): void {
    if(this.calendarContainer) {
      this.calendarContainer;
      let height = this.calendarContainer.nativeElement.offsetHeight + 60;
      this.sessionContainer.setAttribute("style", "min-height: " + height + "px;");
    }
  }

  public selectSession(session: PlacementSession): void {
    let dateHolder = new Date(session.startDate)
    dateHolder.setHours(12, 0, 0 ,0);
    session.startDate = dateHolder;
    this.sessionSelected.emit(session);
  }

  populateSessionCalendar(calendarToOverwrite = null): void {
    if (calendarToOverwrite) {
      this.sessionCalendar = calendarToOverwrite.sessionCalendar;
    }
    let cutOffDate = new Date();
    cutOffDate.setDate(cutOffDate.getDate() + 5);
    cutOffDate.setHours(22, 0, 0, 0);
    
    this.sessionCalendarCurrent = this.sessionCalendar.filter(session => !session.isFuture);
    this.sessionCalendarFuture = this.sessionCalendar.filter(session => session.isFuture);

  }

}
